function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o);
}
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) {
    var e, n, i, u, a = [], f = !0, o = !1;
    try {
        if (i = (t = t.call(r)).next, 0 === l) {
            if (Object(t) !== t)
                return;
            f = !1;
        }
        else
            for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0)
                ;
    }
    catch (r) {
        o = !0, n = r;
    }
    finally {
        try {
            if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u))
                return;
        }
        finally {
            if (o)
                throw n;
        }
    }
    return a;
} }
function _arrayWithHoles(r) { if (Array.isArray(r))
    return r; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
        t && (r = t);
        var _n = 0, F = function F() { };
        return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
} var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try {
        a || null == t["return"] || t["return"]();
    }
    finally {
        if (u)
            throw o;
    } } }; }
function _unsupportedIterableToArray(r, a) { if (r) {
    if ("string" == typeof r)
        return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
} }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++)
    n[e] = r[e]; return n; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
    var o, i = p[t], d = G.p, l = i[2];
    r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
} if (o || r > 1)
    return a; throw y = !0, n; } return function (o, p, l) { if (f > 1)
    throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
    i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
    try {
        if (f = 2, i) {
            if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u)))
                    throw TypeError("iterator result is not an object");
                if (!t.done)
                    return t;
                u = t.value, c < 2 && (c = 0);
            }
            else
                1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
            i = e;
        }
        else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a)
            break;
    }
    catch (t) {
        i = e, c = 1, u = t;
    }
    finally {
        f = 1;
    }
} return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() { } function GeneratorFunction() { } function GeneratorFunctionPrototype() { } t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try {
    i({}, "", {});
}
catch (e) {
    i = 0;
} _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t)
    return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i))
        return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
} return ("string" === r ? String : Number)(t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try {
    var i = n[a](c), u = i.value;
}
catch (n) {
    return void e(n);
} i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
import SettingsIcon from '../../public/Settings.svg';
import { Box, Button, Chip, CircularProgress, Dialog, Divider, MenuItem, Select, TextField, Typography } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import React, { useState, useEffect, useMemo, useContext, useCallback } from 'react';
import Cookies from 'js-cookie';
import { UserAPI } from '../apis/UserAPI';
import { fetchSupportedLanguagesData, buildFallbackLanguageOptions, formatPreferredName, fetchEnabledMessageChannels, buildDefaultMessagePreferences } from '../utils/settingsModalHelpers';
import { constants } from '../constants';
import { handleErrorModal } from './Toast';
import { SETTINGS_VALIDATION } from '@/utils';
import { ConfigContext } from './ConfigContext';
import { useRbacNotifications } from '@/hooks/useRbacNotifications';
import { useThemeDetails } from './ThemeDetailsContext';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { checkProfanity } from '@/utils/profanityCheckUtils';
import { defaultCountries, parseCountry, FlagImage } from 'react-international-phone';
import 'react-international-phone/style.css';
import { parsePhoneNumber, isValidPhoneNumber } from 'libphonenumber-js/mobile';
// Dynamic message preferences - keys are determined by admin configuration
var getChannelLabelFromConstants = function getChannelLabelFromConstants(channelKey, fallback) {
    switch (channelKey) {
        case 'email':
            return constants.settings_message_email;
        case 'sms':
            return constants.settings_message_sms;
        case 'slack':
            return constants.settings_message_slack;
        case 'teams':
            return constants.settings_message_teams;
        case 'webPushNotification':
            return constants.settings_message_web_push_notification;
        default:
            return fallback;
    }
};
// Helper function to normalize notification permission state
var normalizePermissionState = function normalizePermissionState(state) {
    return state === 'prompt' ? 'default' : state;
};
// Helper function to validate cleaned preferred name
var isValidCleanedName = function isValidCleanedName(cleanedName) {
    return cleanedName.length > 0 && cleanedName.length <= SETTINGS_VALIDATION.maxNameLength;
};
// Helper function to check if user has valid ID
var hasValidUserId = function hasValidUserId(user) {
    return Boolean(user && user.id);
};
// Helper function to apply web push notification preference
var applyWebPushNotification = /*#__PURE__*/ function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee(newSettings, isUserSubscribed, notificationPermission, enablePushNotification, disablePushNotification, refreshNotificationPermission, setMessagePreferences) {
        var desiredPush, currentPush, ok;
        return _regenerator().w(function (_context) {
            while (1)
                switch (_context.n) {
                    case 0:
                        desiredPush = Boolean(newSettings.messagePreferences.webPushNotification);
                        currentPush = Boolean(isUserSubscribed);
                        if (!(desiredPush === currentPush)) {
                            _context.n = 1;
                            break;
                        }
                        return _context.a(2);
                    case 1:
                        if (!(desiredPush && notificationPermission === 'denied')) {
                            _context.n = 2;
                            break;
                        }
                        newSettings.messagePreferences.webPushNotification = false;
                        setMessagePreferences(function (prev) {
                            return _objectSpread(_objectSpread({}, prev), {}, {
                                webPushNotification: false
                            });
                        });
                        return _context.a(2);
                    case 2:
                        if (!desiredPush) {
                            _context.n = 6;
                            break;
                        }
                        _context.n = 3;
                        return enablePushNotification();
                    case 3:
                        ok = _context.v;
                        _context.n = 4;
                        return refreshNotificationPermission();
                    case 4:
                        if (!(!ok || Notification.permission === 'denied')) {
                            _context.n = 5;
                            break;
                        }
                        newSettings.messagePreferences.webPushNotification = false;
                        setMessagePreferences(function (prev) {
                            return _objectSpread(_objectSpread({}, prev), {}, {
                                webPushNotification: false
                            });
                        });
                        return _context.a(2);
                    case 5:
                        newSettings.messagePreferences.webPushNotification = true;
                        return _context.a(2);
                    case 6:
                        _context.n = 7;
                        return disablePushNotification();
                    case 7:
                        newSettings.messagePreferences.webPushNotification = false;
                    case 8:
                        return _context.a(2);
                }
        }, _callee);
    }));
    return function applyWebPushNotification(_x, _x2, _x3, _x4, _x5, _x6, _x7) {
        return _ref.apply(this, arguments);
    };
}();
// Helper function to fetch supported languages
var fetchLanguageOptions = /*#__PURE__*/ function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee2(currentSelected, fallbackSelected) {
        var _yield$fetchSupported, options, selected, _buildFallbackLanguag, _options, _selected, _t;
        return _regenerator().w(function (_context2) {
            while (1)
                switch (_context2.p = _context2.n) {
                    case 0:
                        _context2.p = 0;
                        _context2.n = 1;
                        return fetchSupportedLanguagesData(currentSelected, fallbackSelected);
                    case 1:
                        _yield$fetchSupported = _context2.v;
                        options = _yield$fetchSupported.options;
                        selected = _yield$fetchSupported.selected;
                        return _context2.a(2, {
                            options: options,
                            selected: selected,
                            error: null
                        });
                    case 2:
                        _context2.p = 2;
                        _t = _context2.v;
                        _buildFallbackLanguag = buildFallbackLanguageOptions(currentSelected, fallbackSelected), _options = _buildFallbackLanguag.options, _selected = _buildFallbackLanguag.selected;
                        return _context2.a(2, {
                            options: _options,
                            selected: _selected,
                            error: constants.settings_language_error
                        });
                }
        }, _callee2, null, [[0, 2]]);
    }));
    return function fetchLanguageOptions(_x8, _x9) {
        return _ref2.apply(this, arguments);
    };
}();
// Helper function to check user permissions
var checkUserPermissions = /*#__PURE__*/ function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee3(username, handleErrorModalFn) {
        var _policies$resource$so, _policies$resource, policies, hasPermission, _t2;
        return _regenerator().w(function (_context3) {
            while (1)
                switch (_context3.p = _context3.n) {
                    case 0:
                        _context3.p = 0;
                        _context3.n = 1;
                        return UserAPI.getPolicies(username);
                    case 1:
                        policies = _context3.v;
                        hasPermission = (_policies$resource$so = policies === null || policies === void 0 || (_policies$resource = policies.resource) === null || _policies$resource === void 0 ? void 0 : _policies$resource.some(function (policy) {
                            var _policy$resource_acti;
                            return policy === null || policy === void 0 || (_policy$resource_acti = policy.resource_action) === null || _policy$resource_acti === void 0 ? void 0 : _policy$resource_acti.some(function (ra) {
                                var _ra$action;
                                return ra === null || ra === void 0 || (_ra$action = ra.action) === null || _ra$action === void 0 ? void 0 : _ra$action.includes('RBAC:UpdateUser');
                            });
                        })) !== null && _policies$resource$so !== void 0 ? _policies$resource$so : false;
                        if (!hasPermission) {
                            handleErrorModalFn(true, constants.settings_permission_update_denied);
                        }
                        return _context3.a(2, hasPermission);
                    case 2:
                        _context3.p = 2;
                        _t2 = _context3.v;
                        console.error('Failed to check permissions:', _t2);
                        handleErrorModalFn(true, constants.settings_permissions_unverifiable);
                        return _context3.a(2, false);
                }
        }, _callee3, null, [[0, 2]]);
    }));
    return function checkUserPermissions(_x0, _x1) {
        return _ref3.apply(this, arguments);
    };
}();
// Helper function to load enabled message channels
var loadEnabledChannels = /*#__PURE__*/ function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee4() {
        var channels, _t3;
        return _regenerator().w(function (_context4) {
            while (1)
                switch (_context4.p = _context4.n) {
                    case 0:
                        _context4.p = 0;
                        _context4.n = 1;
                        return fetchEnabledMessageChannels();
                    case 1:
                        channels = _context4.v;
                        return _context4.a(2, channels);
                    case 2:
                        _context4.p = 2;
                        _t3 = _context4.v;
                        console.error('Failed to load message channels:', _t3);
                        return _context4.a(2, []);
                }
        }, _callee4, null, [[0, 2]]);
    }));
    return function loadEnabledChannels() {
        return _ref4.apply(this, arguments);
    };
}();
// Helper function to render message type toggle
var renderMessageTypeToggle = function renderMessageTypeToggle(name, active, handleToggler, hasUpdatePermission, buttonColor) {
    return /*#__PURE__*/ React.createElement(Box, {
        sx: {
            display: 'flex',
            alignItems: 'center',
            gap: '8px'
        }
    }, /*#__PURE__*/ React.createElement(Box, {
        onClick: function onClick() {
            return hasUpdatePermission && handleToggler();
        },
        sx: {
            position: 'relative',
            width: 48,
            height: 32,
            cursor: hasUpdatePermission ? 'pointer' : 'not-allowed',
            opacity: hasUpdatePermission ? 1 : 0.5
        }
    }, /*#__PURE__*/ React.createElement(Box, {
        sx: {
            position: 'absolute',
            left: 6,
            top: 8,
            width: 36,
            height: 16,
            borderRadius: '10px',
            backgroundColor: active ? buttonColor : '#EBEBEB',
            opacity: active ? 0.3 : 1,
            transition: 'background-color 300ms',
            pointerEvents: 'none'
        }
    }), /*#__PURE__*/ React.createElement(Box, {
        component: "button",
        role: "switch",
        "aria-checked": active,
        "aria-label": 'Enable ' + name,
        sx: {
            position: 'absolute',
            left: active ? 24 : 7,
            top: 7,
            width: 18,
            height: 18,
            borderRadius: '50%',
            backgroundColor: active ? buttonColor : '#D9D9D9',
            boxShadow: '0px 2px 1px rgba(0, 0, 0, 0.15), 0px 0px 2px rgba(0, 0, 0, 0.12), 0px 1px 1px rgba(0, 0, 0, 0.15)',
            transition: 'left 300ms cubic-bezier(0.4, 0, 0.2, 1), background-color 300ms',
            cursor: 'pointer',
            border: 'none',
            padding: 0,
            pointerEvents: 'none',
            '&:focus': {
                outline: "2px solid ".concat(COLORS.primary),
                outlineOffset: '2px'
            }
        }
    })), /*#__PURE__*/ React.createElement(Box, {
        component: "span",
        sx: descriptionStyle
    }, name));
};
var COLORS = {
    primary: '#26890D',
    primaryHover: '#1f6b0a',
    primaryLight: 'rgba(38, 137, 13, 0.04)',
    textPrimary: '#212121',
    textSecondary: '#666',
    border: '#9E9E9E',
    divider: '#EBEBEB',
    background: '#FFF',
    actionButtonsBackground: '#F8F8F8',
    toggleOff: '#FAFAFA',
    error: '#d32f2f',
    buttonBackground: '#F8F8F8'
};
var headingStyle = {
    color: COLORS.textPrimary,
    fontFamily: 'Open Sans',
    fontSize: '16px',
    fontWeight: 600,
    lineHeight: '152%',
    letterSpacing: '0.15px',
    margin: 0,
    '@media (max-width: 768px)': {
        fontSize: '15px'
    }
};
var descriptionStyle = {
    color: COLORS.textSecondary,
    fontFamily: 'Open Sans',
    fontSize: '16px',
    fontWeight: 400,
    lineHeight: '152%',
    letterSpacing: '0.15px',
    margin: 0,
    '@media (max-width: 768px)': {
        fontSize: '14px'
    }
};
var inputBaseStyle = {
    fontFamily: 'Open Sans',
    fontSize: '16px',
    fontWeight: 400,
    lineHeight: '152%',
    letterSpacing: '0.15px',
    color: COLORS.textPrimary
};
var getNotificationEnableSteps = function getNotificationEnableSteps() {
    var _matched$instruction;
    var NOTIFICATION_DISABLED_PREFIX = constants.notification_disabled_prefix;
    var generic = constants.notification_enable_generic;
    if (typeof navigator === 'undefined') {
        return "".concat(NOTIFICATION_DISABLED_PREFIX, " ").concat(generic);
    }
    var ua = navigator.userAgent.toLowerCase();
    var rules = [{
            test: function test(u) {
                return u.includes('edg/');
            },
            instruction: constants.notification_enable_edge
        }, {
            test: function test(u) {
                return (u.includes('chrome') || u.includes('chromium')) && !u.includes('edg/');
            },
            instruction: constants.notification_enable_chrome
        }, {
            test: function test(u) {
                return u.includes('firefox');
            },
            instruction: constants.notification_enable_firefox
        }, {
            test: function test(u) {
                return u.includes('safari') && !u.includes('chrome') && !u.includes('chromium');
            },
            instruction: constants.notification_enable_safari
        }];
    var matched = rules.find(function (r) {
        return r.test(ua);
    });
    return "".concat(NOTIFICATION_DISABLED_PREFIX, " ").concat((_matched$instruction = matched === null || matched === void 0 ? void 0 : matched.instruction) !== null && _matched$instruction !== void 0 ? _matched$instruction : generic);
};
// Helper: Build message preferences from user data and enabled channels
var buildMessagePreferences = function buildMessagePreferences(enabledChannels, initialUser) {
    var derivedMessagePreferences = buildDefaultMessagePreferences(enabledChannels);
    var _iterator = _createForOfIteratorHelper(enabledChannels), _step;
    try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var _ref5, _initialUser$details$, _initialUser$details, _initialUser$details2;
            var channel = _step.value;
            var channelKey = channel.key;
            derivedMessagePreferences[channelKey] = Boolean((_ref5 = (_initialUser$details$ = initialUser === null || initialUser === void 0 || (_initialUser$details = initialUser.details) === null || _initialUser$details === void 0 || (_initialUser$details = _initialUser$details.messagePreferences) === null || _initialUser$details === void 0 ? void 0 : _initialUser$details[channelKey]) !== null && _initialUser$details$ !== void 0 ? _initialUser$details$ : initialUser === null || initialUser === void 0 || (_initialUser$details2 = initialUser.details) === null || _initialUser$details2 === void 0 ? void 0 : _initialUser$details2[channelKey]) !== null && _ref5 !== void 0 ? _ref5 : false);
        }
    }
    catch (err) {
        _iterator.e(err);
    }
    finally {
        _iterator.f();
    }
    return derivedMessagePreferences;
};
var findCountryByDialCode = function findCountryByDialCode(dialCode) {
    var _iterator2 = _createForOfIteratorHelper(defaultCountries), _step2;
    try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var country = _step2.value;
            var parsed = parseCountry(country);
            if (parsed.dialCode === dialCode) {
                return parsed.iso2;
            }
        }
    }
    catch (err) {
        _iterator2.e(err);
    }
    finally {
        _iterator2.f();
    }
    return 'us';
};
var parseLegacyPhoneNumber = function parseLegacyPhoneNumber(phoneData) {
    if (!phoneData.startsWith('+'))
        return null;
    try {
        var parsed = parsePhoneNumber(phoneData);
        if (parsed) {
            var _parsed$country;
            return {
                country: ((_parsed$country = parsed.country) === null || _parsed$country === void 0 ? void 0 : _parsed$country.toLowerCase()) || 'us',
                number: parsed.nationalNumber
            };
        }
    }
    catch (error) {
        console.warn('Failed to parse phone number:', error);
    }
    return null;
};
// Helper: Parse JSON phone data
var parseJsonPhoneData = function parseJsonPhoneData(phoneData) {
    try {
        var parsed = JSON.parse(phoneData);
        // New format with country and number
        if (parsed !== null && parsed !== void 0 && parsed.country && parsed !== null && parsed !== void 0 && parsed.number) {
            return {
                country: parsed.country.toLowerCase(),
                number: parsed.number
            };
        }
        // Legacy format with dialCode and number
        if (parsed !== null && parsed !== void 0 && parsed.dialCode && parsed !== null && parsed !== void 0 && parsed.number) {
            return {
                country: findCountryByDialCode(parsed.dialCode),
                number: parsed.number
            };
        }
    }
    catch (e) {
        console.error('Failed to parse phone data as JSON:', e);
    }
    return null;
};
// Helper: Parse phone number from JSON or legacy string format
var parsePhoneNumberWithCountry = function parsePhoneNumberWithCountry(phoneData) {
    if (!phoneData) {
        return {
            country: 'us',
            number: ''
        };
    }
    var jsonResult = parseJsonPhoneData(phoneData);
    if (jsonResult)
        return jsonResult;
    // Try legacy format (full phone number with + prefix)
    var legacyResult = parseLegacyPhoneNumber(phoneData);
    if (legacyResult)
        return legacyResult;
    return {
        country: 'us',
        number: ''
    };
};
var initializeSettingsFromUser = function initializeSettingsFromUser(enabledChannels, initialUser) {
    var _initialUser$userAttr, _initialUser$details3, _initialUser$details$2, _initialUser$details4, _initialUser$userAttr2;
    var cookiePreferredName = (initialUser === null || initialUser === void 0 || (_initialUser$userAttr = initialUser.userAttributes) === null || _initialUser$userAttr === void 0 || (_initialUser$userAttr = _initialUser$userAttr.name) === null || _initialUser$userAttr === void 0 ? void 0 : _initialUser$userAttr.trim()) || '';
    var cookieLang = (initialUser === null || initialUser === void 0 || (_initialUser$details3 = initialUser.details) === null || _initialUser$details3 === void 0 || (_initialUser$details3 = _initialUser$details3.selected_language) === null || _initialUser$details3 === void 0 || (_initialUser$details3 = _initialUser$details3.trim()) === null || _initialUser$details3 === void 0 ? void 0 : _initialUser$details3.toLowerCase()) || 'en';
    var cookieAudio = (_initialUser$details$2 = initialUser === null || initialUser === void 0 || (_initialUser$details4 = initialUser.details) === null || _initialUser$details4 === void 0 ? void 0 : _initialUser$details4.audio) !== null && _initialUser$details$2 !== void 0 ? _initialUser$details$2 : false;
    var cookiePhoneNumber = (initialUser === null || initialUser === void 0 || (_initialUser$userAttr2 = initialUser.userAttributes) === null || _initialUser$userAttr2 === void 0 ? void 0 : _initialUser$userAttr2.phone) || '';
    var messagePreferences = buildMessagePreferences(enabledChannels, initialUser);
    return {
        preferredName: cookiePreferredName,
        phoneNumber: cookiePhoneNumber,
        selectedLanguage: cookieLang,
        audio: cookieAudio,
        messagePreferences: messagePreferences
    };
};
// Helper: Update user cookie with new data
var updateUserCookie = function updateUserCookie(updatedUser, newSettings) {
    var _updatedUser$details;
    var patchedUser = _objectSpread(_objectSpread({}, updatedUser), {}, {
        userAttributes: _objectSpread(_objectSpread({}, updatedUser.userAttributes), {}, {
            phone: newSettings.phoneNumber
        }),
        details: _objectSpread(_objectSpread({}, updatedUser.details), {}, {
            messagePreferences: _objectSpread(_objectSpread({}, (_updatedUser$details = updatedUser.details) === null || _updatedUser$details === void 0 ? void 0 : _updatedUser$details.messagePreferences), newSettings.messagePreferences)
        })
    });
    try {
        Cookies.remove('user', {
            path: '/'
        });
        Cookies.set('user', JSON.stringify(patchedUser), {
            secure: true,
            sameSite: 'Strict',
            path: '/'
        });
    }
    catch (e) {
        console.warn('[SettingsModal] failed to refresh user cookie', e);
    }
};
// Notification warning styles
var notificationWarningStyles = {
    container: {
        mt: '12px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: '12px',
        px: '16px',
        py: '10px'
    },
    content: {
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
        minWidth: 0
    },
    icon: {
        fontSize: '20px',
        flexShrink: 0
    },
    text: {
        fontFamily: 'Open Sans',
        fontSize: '14px',
        lineHeight: '20px',
        whiteSpace: 'normal',
        overflowWrap: 'anywhere'
    }
};
// Channel toggle item component to reduce complexity in main render
var ChannelToggleItem = function ChannelToggleItem(_ref6) {
    var channel = _ref6.channel, messagePreferences = _ref6.messagePreferences, notificationPermission = _ref6.notificationPermission, renderChannelToggle = _ref6.renderChannelToggle, toggleInBrowser = _ref6.toggleInBrowser, toggleMessagePreference = _ref6.toggleMessagePreference;
    var isWebPush = channel.key === 'webPushNotification';
    var isActive = Boolean(messagePreferences[channel.key]);
    var showWarning = isWebPush && notificationPermission === 'denied' && !isActive;
    var handleToggle = isWebPush ? toggleInBrowser : function () {
        return toggleMessagePreference(channel.key);
    };
    return /*#__PURE__*/ React.createElement(Box, null, renderChannelToggle(channel.label, isActive, handleToggle), showWarning && /*#__PURE__*/ React.createElement(Box, {
        sx: notificationWarningStyles.container
    }, /*#__PURE__*/ React.createElement(Box, {
        sx: notificationWarningStyles.content
    }, /*#__PURE__*/ React.createElement(ErrorOutlineIcon, {
        sx: notificationWarningStyles.icon
    }), /*#__PURE__*/ React.createElement(Typography, {
        sx: notificationWarningStyles.text
    }, getNotificationEnableSteps()))));
};
// Default settings state
var DEFAULT_SETTINGS = {
    preferredName: '',
    phoneNumber: '',
    selectedLanguage: 'en',
    audio: false,
    messagePreferences: {}
};
// Loading view component to reduce cognitive complexity
var SettingsLoadingView = function SettingsLoadingView(_ref7) {
    var buttonColor = _ref7.buttonColor;
    var _useThemeDetails = useThemeDetails(), stateImages = _useThemeDetails.stateImages;
    return /*#__PURE__*/ React.createElement(Box, {
        sx: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '24px',
            minHeight: '300px',
            gap: '16px',
            '@media (max-width: 768px)': {
                padding: '16px',
                gap: '12px'
            }
        },
        "aria-label": "Loading settings"
    }, stateImages !== null && stateImages !== void 0 && stateImages.Loading ? /*#__PURE__*/ React.createElement(Box, {
        component: "img",
        src: stateImages.Loading,
        alt: "Loading",
        sx: {
            width: 128,
            height: 128
        }
    }) : /*#__PURE__*/ React.createElement(CircularProgress, {
        size: 64,
        thickness: 4,
        sx: {
            color: buttonColor
        }
    }), /*#__PURE__*/ React.createElement(Box, {
        component: "p",
        sx: {
            fontFamily: 'Open Sans',
            fontWeight: 600,
            fontSize: '20px',
            lineHeight: '152%',
            letterSpacing: '0.15px',
            textAlign: 'center',
            color: COLORS.textPrimary,
            margin: 0
        }
    }, constants.loading));
};
// Footer component to reduce cognitive complexity
var SettingsFooter = function SettingsFooter(_ref8) {
    var onClose = _ref8.onClose, handleSave = _ref8.handleSave, languageLoading = _ref8.languageLoading, preferredNameError = _ref8.preferredNameError, phoneNumberError = _ref8.phoneNumberError, isDirty = _ref8.isDirty, hasUpdatePermission = _ref8.hasUpdatePermission, buttonColor = _ref8.buttonColor;
    var isSaveDisabled = !!preferredNameError || !!phoneNumberError || !isDirty || !hasUpdatePermission;
    return /*#__PURE__*/ React.createElement(Box, {
        sx: {
            display: 'flex',
            padding: '16px 24px',
            gap: '16px',
            borderRadius: '0 0 24px 24px',
            background: COLORS.actionButtonsBackground,
            borderTop: "1px solid ".concat(COLORS.divider),
            flexShrink: 0,
            '@media (max-width: 768px)': {
                padding: '12px 16px',
                gap: '12px'
            }
        }
    }, /*#__PURE__*/ React.createElement(Button, {
        onClick: onClose,
        sx: {
            padding: '8px 16px',
            borderRadius: '4px',
            color: buttonColor,
            fontFamily: 'Open Sans',
            fontSize: '16px',
            fontWeight: 600,
            lineHeight: '168%',
            letterSpacing: '0.4px',
            textTransform: 'none',
            '@media (max-width: 768px)': {
                fontSize: '15px',
                padding: '8px 12px'
            }
        }
    }, constants.settings_button_cancel), !languageLoading && /*#__PURE__*/ React.createElement(Box, {
        sx: {
            flex: '1 0 0',
            display: 'flex',
            justifyContent: 'flex-end'
        }
    }, /*#__PURE__*/ React.createElement(Button, {
        onClick: handleSave,
        variant: "contained",
        disabled: isSaveDisabled,
        sx: {
            padding: '8px 16px',
            borderRadius: '4px',
            backgroundColor: isSaveDisabled ? '#9e9e9e' : buttonColor,
            color: '#FFF',
            fontFamily: 'Open Sans',
            fontSize: '16px',
            fontWeight: 600,
            lineHeight: '168%',
            letterSpacing: '0.4px',
            textTransform: 'none',
            boxShadow: 'none',
            '&:hover': {
                boxShadow: 'none'
            },
            '&.Mui-disabled': {
                backgroundColor: '#9e9e9e',
                color: '#FFF'
            },
            '@media (max-width: 768px)': {
                fontSize: '15px',
                padding: '8px 12px'
            }
        }
    }, constants.settings_button_save)));
};
var SettingsModal = function SettingsModal(_ref9) {
    var _configState$settings, _configState$settings2, _configState$settings3, _configState$settings4, _configState$settings5, _configState$settings6, _configState$settings7, _configState$settings8, _configState$settings9;
    var open = _ref9.open, onClose = _ref9.onClose, onUpdate = _ref9.onUpdate, initialUser = _ref9.initialUser;
    // Core settings state
    var _useState = useState(DEFAULT_SETTINGS), _useState2 = _slicedToArray(_useState, 2), originalSettings = _useState2[0], setOriginalSettings = _useState2[1];
    var _useState3 = useState(''), _useState4 = _slicedToArray(_useState3, 2), preferredName = _useState4[0], setPreferredName = _useState4[1];
    var _useState5 = useState(null), _useState6 = _slicedToArray(_useState5, 2), preferredNameError = _useState6[0], setPreferredNameError = _useState6[1];
    var _useState7 = useState(''), _useState8 = _slicedToArray(_useState7, 2), phoneNumber = _useState8[0], setPhoneNumber = _useState8[1];
    var _useState9 = useState(null), _useState0 = _slicedToArray(_useState9, 2), phoneNumberError = _useState0[0], setPhoneNumberError = _useState0[1];
    var _useState1 = useState('us'), _useState10 = _slicedToArray(_useState1, 2), selectedCountry = _useState10[0], setSelectedCountry = _useState10[1];
    var _useState11 = useState(''), _useState12 = _slicedToArray(_useState11, 2), countrySearchTerm = _useState12[0], setCountrySearchTerm = _useState12[1];
    var _useState13 = useState('en'), _useState14 = _slicedToArray(_useState13, 2), selectedLanguage = _useState14[0], setSelectedLanguage = _useState14[1];
    var _useState15 = useState(false), _useState16 = _slicedToArray(_useState15, 2), audio = _useState16[0], setAudio = _useState16[1];
    var _useState17 = useState({}), _useState18 = _slicedToArray(_useState17, 2), messagePreferences = _useState18[0], setMessagePreferences = _useState18[1];
    // Channels state
    var _useState19 = useState([]), _useState20 = _slicedToArray(_useState19, 2), enabledChannels = _useState20[0], setEnabledChannels = _useState20[1];
    var _useState21 = useState(true), _useState22 = _slicedToArray(_useState21, 2), channelsLoading = _useState22[0], setChannelsLoading = _useState22[1];
    // Language state
    var _useState23 = useState([]), _useState24 = _slicedToArray(_useState23, 2), languageOptions = _useState24[0], setLanguageOptions = _useState24[1];
    var _useState25 = useState(false), _useState26 = _slicedToArray(_useState25, 2), languageLoading = _useState26[0], setLanguageLoading = _useState26[1];
    var _useState27 = useState(null), _useState28 = _slicedToArray(_useState27, 2), languageError = _useState28[0], setLanguageError = _useState28[1];
    // Roles state
    var _useState29 = useState([]), _useState30 = _slicedToArray(_useState29, 2), userRoles = _useState30[0], setUserRoles = _useState30[1];
    var _useState31 = useState(false), _useState32 = _slicedToArray(_useState31, 2), rolesLoading = _useState32[0], setRolesLoading = _useState32[1];
    // Permissions state
    var _useState33 = useState(true), _useState34 = _slicedToArray(_useState33, 2), hasUpdatePermission = _useState34[0], setHasUpdatePermission = _useState34[1];
    var _useState35 = useState('default'), _useState36 = _slicedToArray(_useState35, 2), notificationPermission = _useState36[0], setNotificationPermission = _useState36[1];
    // Hooks
    var _useRbacNotifications = useRbacNotifications(), isUserSubscribed = _useRbacNotifications.isUserSubscribed, enablePushNotification = _useRbacNotifications.enablePushNotification, disablePushNotification = _useRbacNotifications.disablePushNotification;
    var _useContext = useContext(ConfigContext), configState = _useContext.configState;
    var buttonColor = (_configState$settings = configState === null || configState === void 0 || (_configState$settings2 = configState.settings) === null || _configState$settings2 === void 0 ? void 0 : _configState$settings2.button_color) !== null && _configState$settings !== void 0 ? _configState$settings : COLORS.primary;
    var refreshNotificationPermission = useCallback(/*#__PURE__*/ _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee5() {
        var _navigator$permission, status, _t4;
        return _regenerator().w(function (_context5) {
            while (1)
                switch (_context5.p = _context5.n) {
                    case 0:
                        if ('Notification' in globalThis) {
                            _context5.n = 1;
                            break;
                        }
                        return _context5.a(2);
                    case 1:
                        _context5.p = 1;
                        if (!('permissions' in navigator && (_navigator$permission = navigator.permissions) !== null && _navigator$permission !== void 0 && _navigator$permission.query)) {
                            _context5.n = 3;
                            break;
                        }
                        _context5.n = 2;
                        return navigator.permissions.query({
                            name: 'notifications'
                        });
                    case 2:
                        status = _context5.v;
                        setNotificationPermission(normalizePermissionState(status.state));
                        status.onchange = function () {
                            setNotificationPermission(normalizePermissionState(status.state));
                        };
                        return _context5.a(2);
                    case 3:
                        _context5.n = 5;
                        break;
                    case 4:
                        _context5.p = 4;
                        _t4 = _context5.v;
                    case 5:
                        setNotificationPermission(Notification.permission);
                    case 6:
                        return _context5.a(2);
                }
        }, _callee5, null, [[1, 4]]);
    })), []);
    useEffect(function () {
        if (!open)
            return;
        if (notificationPermission === 'denied' && messagePreferences.webPushNotification) {
            setMessagePreferences(function (prev) {
                return _objectSpread(_objectSpread({}, prev), {}, {
                    webPushNotification: false
                });
            });
            disablePushNotification()["catch"](function () { });
        }
    }, [open, notificationPermission, messagePreferences.webPushNotification, disablePushNotification]);
    useEffect(function () {
        if (!open)
            return;
        refreshNotificationPermission();
        var onFocus = function onFocus() {
            return refreshNotificationPermission();
        };
        var onVisibility = function onVisibility() {
            if (document.visibilityState !== 'visible')
                return;
            refreshNotificationPermission();
        };
        window.addEventListener('focus', onFocus);
        document.addEventListener('visibilitychange', onVisibility);
        return function () {
            window.removeEventListener('focus', onFocus);
            document.removeEventListener('visibilitychange', onVisibility);
        };
    }, [open, refreshNotificationPermission]);
    // Single effect to load all modal data in parallel on open.
    // Permissions, roles and channels are independent — run them concurrently.
    useEffect(function () {
        if (!open)
            return;
        var cancelled = false;
        setLanguageLoading(true);
        setChannelsLoading(true);
        setRolesLoading(true);
        function loadModalData() {
            return _loadModalData.apply(this, arguments);
        }
        function _loadModalData() {
            _loadModalData = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee6() {
                var _yield$Promise$all, _yield$Promise$all2, channels;
                return _regenerator().w(function (_context6) {
                    while (1)
                        switch (_context6.n) {
                            case 0:
                                _context6.n = 1;
                                return Promise.all([
                                    // 1. Load message channels (result needed by the settings initialiser)
                                    loadEnabledChannels(),
                                    // 2. Check update permission
                                    initialUser !== null && initialUser !== void 0 && initialUser.username ? checkUserPermissions(initialUser.username, handleErrorModal).then(function (hasPermission) {
                                        if (!cancelled)
                                            setHasUpdatePermission(hasPermission);
                                    }) : Promise.resolve(),
                                    // 3. Load roles
                                    UserAPI.getRoles(initialUser === null || initialUser === void 0 ? void 0 : initialUser.username).then(function (response) {
                                        if (!cancelled)
                                            setUserRoles((response === null || response === void 0 ? void 0 : response.resource) || []);
                                    })["catch"](function (err) {
                                        console.error('[SettingsModal] Failed to load roles:', err);
                                        if (!cancelled)
                                            setUserRoles([]);
                                    })["finally"](function () {
                                        if (!cancelled)
                                            setRolesLoading(false);
                                    })
                                ]);
                            case 1:
                                _yield$Promise$all = _context6.v;
                                _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 1);
                                channels = _yield$Promise$all2[0];
                                if (!cancelled) {
                                    _context6.n = 2;
                                    break;
                                }
                                return _context6.a(2);
                            case 2:
                                setEnabledChannels(channels);
                                setChannelsLoading(false);
                            case 3:
                                return _context6.a(2);
                        }
                }, _callee6);
            }));
            return _loadModalData.apply(this, arguments);
        }
        loadModalData();
        return function () {
            cancelled = true;
        };
    }, [open, initialUser === null || initialUser === void 0 ? void 0 : initialUser.username]);
    var initializeSettings = function initializeSettings(derived) {
        setOriginalSettings(derived);
        setPreferredName(derived.preferredName);
        // Parse phone number with country code
        var _parsePhoneNumberWith = parsePhoneNumberWithCountry(derived.phoneNumber), country = _parsePhoneNumberWith.country, number = _parsePhoneNumberWith.number;
        setSelectedCountry(country);
        setPhoneNumber(number);
        setPhoneNumberError(null);
        setSelectedLanguage(derived.selectedLanguage);
        setAudio(derived.audio);
        setMessagePreferences(derived.messagePreferences);
        setPreferredNameError(null);
        fetchSupportedLanguages(derived.selectedLanguage);
    };
    useEffect(function () {
        if (!open || channelsLoading)
            return;
        var derived = initializeSettingsFromUser(enabledChannels, initialUser);
        initializeSettings(derived);
    }, [open, initialUser, enabledChannels, channelsLoading]);
    function fetchSupportedLanguages(_x10) {
        return _fetchSupportedLanguages.apply(this, arguments);
    }
    function _fetchSupportedLanguages() {
        _fetchSupportedLanguages = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee0(currentSelected) {
            var _yield$fetchLanguageO, options, selected, error;
            return _regenerator().w(function (_context0) {
                while (1)
                    switch (_context0.n) {
                        case 0:
                            setLanguageLoading(true);
                            _context0.n = 1;
                            return fetchLanguageOptions(currentSelected, selectedLanguage);
                        case 1:
                            _yield$fetchLanguageO = _context0.v;
                            options = _yield$fetchLanguageO.options;
                            selected = _yield$fetchLanguageO.selected;
                            error = _yield$fetchLanguageO.error;
                            setLanguageOptions(options);
                            setSelectedLanguage(selected);
                            setLanguageError(error);
                            setLanguageLoading(false);
                        case 2:
                            return _context0.a(2);
                    }
            }, _callee0);
        }));
        return _fetchSupportedLanguages.apply(this, arguments);
    }
    var validatePreferredName = useCallback(function (value) {
        var collapsed = value.replaceAll(/\s+/g, ' ').trim();
        if (!collapsed)
            return constants.settings_preferred_name_required;
        if (!SETTINGS_VALIDATION.nameAllowedChars.test(collapsed))
            return constants.settings_preferred_name_invalid_chars;
        if (!SETTINGS_VALIDATION.nameHasLetter.test(collapsed))
            return constants.settings_preferred_name_no_letter;
        if (collapsed.length > SETTINGS_VALIDATION.maxNameLength)
            return constants.settings_preferred_name_max_length;
        if (checkProfanity(collapsed))
            return constants.settings_preferred_name_profanity_error;
        return null;
    }, []);
    var handlePreferredNameChange = useCallback(function (event) {
        var value = event.target.value;
        setPreferredName(value);
        setPreferredNameError(validatePreferredName(value));
    }, [validatePreferredName]);
    var validatePhoneNumber = useCallback(function (value, countryCode, isSmsEnabled) {
        // Phone number is mandatory when SMS is enabled
        if (!value) {
            return isSmsEnabled ? constants.settings_phone_number_required : null;
        }
        try {
            // Get the country dial code
            var country = defaultCountries.find(function (c) {
                return c[1] === countryCode;
            });
            if (!country)
                return constants.settings_invalid_country_selected;
            var _parseCountry = parseCountry(country), dialCode = _parseCountry.dialCode;
            var fullNumber = "+".concat(dialCode).concat(value);
            // Validate using libphonenumber-js
            var upperCountryCode = countryCode.toUpperCase();
            if (!isValidPhoneNumber(fullNumber, upperCountryCode)) {
                // Try to get more specific error
                try {
                    var phoneNumberObj = parsePhoneNumber(fullNumber, upperCountryCode);
                    if (!phoneNumberObj) {
                        return constants.settings_invalid_phone_number(country[0]);
                    }
                    if (!phoneNumberObj.isValid()) {
                        return constants.settings_invalid_phone_number_format(country[0]);
                    }
                }
                catch (_unused3) {
                    return constants.settings_invalid_phone_number(country[0]);
                }
                return constants.settings_invalid_phone_number(country[0]);
            }
            return null;
        }
        catch (error) {
            console.error('Invalid phone number', error);
            return constants.settings_invalid_phone_number(countryCode);
        }
    }, []);
    var handlePhoneNumberChange = useCallback(function (event) {
        var value = event.target.value.replaceAll(/\D/g, ''); // Only numeric input
        setPhoneNumber(value);
        var isSmsEnabled = Boolean(messagePreferences.sms);
        setPhoneNumberError(validatePhoneNumber(value, selectedCountry, isSmsEnabled));
    }, [validatePhoneNumber, selectedCountry, messagePreferences.sms]);
    var handleCountryChange = useCallback(function (e) {
        setSelectedCountry(e.target.value);
        // Re-validate phone number with new country
        var isSmsEnabled = Boolean(messagePreferences.sms);
        if (phoneNumber || isSmsEnabled) {
            setPhoneNumberError(validatePhoneNumber(phoneNumber, e.target.value, isSmsEnabled));
        }
    }, [phoneNumber, validatePhoneNumber, messagePreferences.sms]);
    // Filter countries based on search term
    var filteredCountries = useMemo(function () {
        if (!countrySearchTerm.trim())
            return defaultCountries;
        var searchLower = countrySearchTerm.toLowerCase();
        return defaultCountries.filter(function (country) {
            var parsed = parseCountry(country);
            return parsed.name.toLowerCase().includes(searchLower) || parsed.dialCode.includes(searchLower) || parsed.iso2.toLowerCase().includes(searchLower);
        });
    }, [countrySearchTerm]);
    var isDirty = useMemo(function () {
        var _parsePhoneNumberWith2 = parsePhoneNumberWithCountry(originalSettings.phoneNumber), origCountry = _parsePhoneNumberWith2.country, origNumber = _parsePhoneNumberWith2.number;
        var basicFieldsChanged = preferredName !== originalSettings.preferredName || phoneNumber !== origNumber || selectedCountry !== origCountry || selectedLanguage !== originalSettings.selectedLanguage || audio !== originalSettings.audio;
        var preferencesChanged = enabledChannels.some(function (ch) {
            var _originalSettings$mes;
            return Boolean(messagePreferences[ch.key]) !== Boolean((_originalSettings$mes = originalSettings.messagePreferences) === null || _originalSettings$mes === void 0 ? void 0 : _originalSettings$mes[ch.key]);
        });
        return basicFieldsChanged || preferencesChanged;
    }, [preferredName, phoneNumber, selectedCountry, selectedLanguage, audio, originalSettings, messagePreferences, enabledChannels]);
    var applyWebPushPreference = /*#__PURE__*/ function () {
        var _ref1 = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee7(newSettings) {
            return _regenerator().w(function (_context7) {
                while (1)
                    switch (_context7.n) {
                        case 0:
                            _context7.n = 1;
                            return applyWebPushNotification(newSettings, isUserSubscribed, notificationPermission, enablePushNotification, disablePushNotification, refreshNotificationPermission, setMessagePreferences);
                        case 1:
                            return _context7.a(2);
                    }
            }, _callee7);
        }));
        return function applyWebPushPreference(_x11) {
            return _ref1.apply(this, arguments);
        };
    }();
    var validateAndGetCleanedName = useCallback(function () {
        if (preferredNameError)
            return null;
        var cleanedName = formatPreferredName(preferredName);
        if (!isValidCleanedName(cleanedName)) {
            setPreferredNameError(constants.settings_preferred_name_max_length);
            return null;
        }
        return cleanedName;
    }, [preferredName, preferredNameError]);
    var buildNewSettings = useCallback(function (cleanedName) {
        var country = defaultCountries.find(function (c) {
            return c[1] === selectedCountry;
        });
        var dialCode = country ? parseCountry(country).dialCode : '1';
        return {
            preferredName: cleanedName,
            phoneNumber: phoneNumber ? JSON.stringify({
                country: selectedCountry,
                dialCode: dialCode,
                number: phoneNumber
            }) : '',
            selectedLanguage: selectedLanguage,
            audio: audio,
            messagePreferences: _objectSpread({}, messagePreferences)
        };
    }, [phoneNumber, selectedCountry, selectedLanguage, audio, messagePreferences]);
    var finalizeSettings = useCallback(function (newSettings, updatedUser) {
        onUpdate(newSettings, updatedUser);
        setOriginalSettings(newSettings);
        onClose();
        setTimeout(function () {
            var _globalThis$location;
            return globalThis === null || globalThis === void 0 || (_globalThis$location = globalThis.location) === null || _globalThis$location === void 0 ? void 0 : _globalThis$location.reload();
        }, SETTINGS_VALIDATION.reloadDelay);
    }, [onUpdate, onClose]);
    var saveUserPreferences = useCallback(/*#__PURE__*/ function () {
        var _ref10 = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee8(newSettings) {
            var _response$resource, phoneObj, response, updatedUser, _t5;
            return _regenerator().w(function (_context8) {
                while (1)
                    switch (_context8.p = _context8.n) {
                        case 0:
                            _context8.p = 0;
                            // Parse phone object from JSON string
                            phoneObj = null;
                            if (newSettings.phoneNumber) {
                                try {
                                    phoneObj = JSON.parse(newSettings.phoneNumber);
                                }
                                catch (e) {
                                    console.warn('Failed to parse phone number:', e);
                                }
                            }
                            _context8.n = 1;
                            return UserAPI.updateUserPreferences(initialUser, {
                                preferredName: newSettings.preferredName,
                                phone: phoneObj,
                                selectedLanguage: newSettings.selectedLanguage,
                                audio: newSettings.audio,
                                messagePreferences: newSettings.messagePreferences
                            });
                        case 1:
                            response = _context8.v;
                            updatedUser = response === null || response === void 0 || (_response$resource = response.resource) === null || _response$resource === void 0 ? void 0 : _response$resource[0];
                            if (updatedUser)
                                updateUserCookie(updatedUser, newSettings);
                            finalizeSettings(newSettings, updatedUser);
                            _context8.n = 3;
                            break;
                        case 2:
                            _context8.p = 2;
                            _t5 = _context8.v;
                            console.warn('[SettingsModal] preference update failed', _t5);
                            finalizeSettings(newSettings);
                        case 3:
                            return _context8.a(2);
                    }
            }, _callee8, null, [[0, 2]]);
        }));
        return function (_x12) {
            return _ref10.apply(this, arguments);
        };
    }(), [initialUser, finalizeSettings]);
    var handleSave = useCallback(/*#__PURE__*/ _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee9() {
        var cleanedName, newSettings, hasWebPush;
        return _regenerator().w(function (_context9) {
            while (1)
                switch (_context9.n) {
                    case 0:
                        cleanedName = validateAndGetCleanedName();
                        if (cleanedName) {
                            _context9.n = 1;
                            break;
                        }
                        return _context9.a(2);
                    case 1:
                        newSettings = buildNewSettings(cleanedName);
                        hasWebPush = enabledChannels.some(function (c) {
                            return c.key === 'webPushNotification';
                        });
                        if (!hasWebPush) {
                            _context9.n = 3;
                            break;
                        }
                        _context9.n = 2;
                        return applyWebPushPreference(newSettings);
                    case 2:
                        _context9.n = 4;
                        break;
                    case 3:
                        delete newSettings.messagePreferences.webPushNotification;
                    case 4:
                        if (!hasValidUserId(initialUser)) {
                            _context9.n = 6;
                            break;
                        }
                        _context9.n = 5;
                        return saveUserPreferences(newSettings);
                    case 5:
                        _context9.n = 7;
                        break;
                    case 6:
                        finalizeSettings(newSettings);
                    case 7:
                        return _context9.a(2);
                }
        }, _callee9);
    })), [validateAndGetCleanedName, buildNewSettings, enabledChannels, applyWebPushPreference, initialUser, saveUserPreferences, finalizeSettings]);
    var renderChannelToggle = useCallback(function (name, active, handleToggler) {
        return renderMessageTypeToggle(name, active, handleToggler, hasUpdatePermission, buttonColor);
    }, [hasUpdatePermission, buttonColor]);
    var toggleMessagePreference = useCallback(function (key) {
        if (!hasUpdatePermission)
            return;
        var newValue = !messagePreferences[key];
        setMessagePreferences(function (prev) {
            return _objectSpread(_objectSpread({}, prev), {}, _defineProperty({}, key, newValue));
        });
        // If toggling SMS, validate phone number
        if (key === 'sms') {
            setPhoneNumberError(validatePhoneNumber(phoneNumber, selectedCountry, newValue));
        }
    }, [hasUpdatePermission, messagePreferences, validatePhoneNumber, phoneNumber, selectedCountry]);
    var toggleInBrowser = useCallback(function () {
        if (!hasUpdatePermission)
            return;
        var turningOn = !messagePreferences.webPushNotification;
        var canEnable = !(turningOn && notificationPermission === 'denied');
        setMessagePreferences(function (prev) {
            return _objectSpread(_objectSpread({}, prev), {}, {
                webPushNotification: canEnable ? turningOn : false
            });
        });
    }, [hasUpdatePermission, messagePreferences.webPushNotification, notificationPermission]);
    return /*#__PURE__*/ React.createElement(Dialog, {
        open: open,
        onClose: onClose,
        maxWidth: "sm",
        fullWidth: true,
        sx: {
            '& .MuiDialog-paper': {
                borderRadius: '24px',
                maxWidth: '800px',
                width: '744px',
                // Never exceed viewport height;
                maxHeight: 'min(700px, calc(100dvh - 32px))',
                height: 'auto',
                margin: '16px',
                overflow: 'hidden',
                display: 'flex',
                flexDirection: 'column',
                '@media (max-width: 768px)': {
                    maxWidth: '95vw',
                    maxHeight: 'calc(100dvh - 16px)',
                    margin: '8px'
                },
                '@media (max-width: 1366px)': {
                    maxWidth: '520px'
                },
                '& > div': {
                    overflow: 'auto',
                    '&::-webkit-scrollbar': {
                        width: '10px'
                    },
                    '&::-webkit-scrollbar-button': {
                        display: 'none'
                    }
                }
            }
        }
    }, /*#__PURE__*/ React.createElement(Box, {
        sx: {
            display: 'flex',
            flexDirection: 'column',
            flex: 1,
            minHeight: 0,
            overflow: 'hidden'
        }
    }, /*#__PURE__*/ React.createElement(Box, {
        sx: {
            display: 'flex',
            padding: '12px 24px',
            alignItems: 'center',
            gap: '12px',
            '@media (max-width: 768px)': {
                padding: '12px 16px'
            }
        }
    }, /*#__PURE__*/ React.createElement(Box, {
        component: "img",
        src: SettingsIcon,
        alt: constants.settings_icon_alt,
        sx: {
            width: 24,
            height: 24,
            filter: 'brightness(0)'
        }
    }), /*#__PURE__*/ React.createElement(Box, {
        component: "h2",
        sx: _objectSpread(_objectSpread({}, headingStyle), {}, {
            fontSize: '20px',
            flex: 1,
            '@media (max-width: 768px)': {
                fontSize: '18px'
            }
        })
    }, constants.settings_title)), /*#__PURE__*/ React.createElement(Divider, {
        sx: {
            borderColor: COLORS.divider
        }
    }), languageLoading ? /*#__PURE__*/ React.createElement(SettingsLoadingView, {
        buttonColor: (configState === null || configState === void 0 || (_configState$settings3 = configState.settings) === null || _configState$settings3 === void 0 ? void 0 : _configState$settings3.button_color) || COLORS.primary
    }) : /*#__PURE__*/ React.createElement(Box, {
        sx: {
            display: 'flex',
            flexDirection: 'column',
            gap: '16px',
            padding: '24px',
            flex: 1,
            minHeight: 0,
            overflow: 'auto',
            '&::-webkit-scrollbar': {
                width: '10px'
            },
            '&::-webkit-scrollbar-button': {
                display: 'none'
            },
            '@media (max-width: 768px)': {
                padding: '16px',
                gap: '12px'
            }
        }
    }, /*#__PURE__*/ React.createElement(Box, {
        sx: {
            display: 'flex',
            flexDirection: 'column',
            gap: '8px'
        }
    }, /*#__PURE__*/ React.createElement(Box, {
        component: "h3",
        sx: headingStyle
    }, constants.settings_preferred_name_heading), /*#__PURE__*/ React.createElement(Box, {
        component: "p",
        sx: descriptionStyle
    }, constants.settings_preferred_name_description), /*#__PURE__*/ React.createElement(TextField, {
        fullWidth: true,
        size: "small",
        value: preferredName,
        onChange: handlePreferredNameChange,
        disabled: !hasUpdatePermission,
        error: !!preferredNameError,
        helperText: preferredNameError || constants.settings_preferred_name_helper,
        sx: {
            '& .MuiOutlinedInput-root': _objectSpread(_objectSpread({
                padding: '8px 12px',
                borderRadius: '4px'
            }, inputBaseStyle), {}, {
                '& fieldset': {
                    borderColor: COLORS.border
                },
                '&:hover fieldset': {
                    borderColor: COLORS.border
                },
                '&.Mui-focused fieldset': {
                    borderColor: COLORS.primary,
                    borderWidth: '1px'
                },
                '&.Mui-error fieldset': {
                    borderColor: COLORS.error
                }
            }),
            '& .MuiOutlinedInput-input': {
                padding: 0
            },
            '& .MuiFormHelperText-root': {
                fontFamily: 'Open Sans',
                fontSize: '12px',
                lineHeight: '128%',
                marginLeft: 0,
                marginTop: '4px'
            }
        }
    })), /*#__PURE__*/ React.createElement(Divider, {
        sx: {
            borderColor: COLORS.divider
        }
    }), /*#__PURE__*/ React.createElement(Box, {
        sx: {
            display: 'flex',
            flexDirection: 'column',
            gap: '8px'
        }
    }, /*#__PURE__*/ React.createElement(Box, {
        component: "h3",
        sx: headingStyle
    }, constants.settings_tab_roles), rolesLoading && /*#__PURE__*/ React.createElement(CircularProgress, {
        size: 16
    }), !rolesLoading && userRoles.length > 0 && /*#__PURE__*/ React.createElement(Box, {
        sx: {
            display: 'flex',
            flexWrap: 'wrap',
            gap: '6px'
        }
    }, userRoles.map(function (role) {
        return /*#__PURE__*/ React.createElement(Chip, {
            key: role.role_id,
            label: role.role_name,
            size: "small",
            sx: {
                backgroundColor: '#f0f0f0',
                color: '#595959',
                fontFamily: 'Open Sans',
                fontSize: 12,
                fontWeight: 600,
                height: 24
            }
        });
    })), !rolesLoading && userRoles.length === 0 && /*#__PURE__*/ React.createElement(Typography, {
        variant: "body2",
        sx: {
            fontSize: '14px',
            color: '#888'
        }
    }, constants.settings_roles_no_assigned)), /*#__PURE__*/ React.createElement(Divider, {
        sx: {
            borderColor: COLORS.divider
        }
    }), /*#__PURE__*/ React.createElement(Box, {
        sx: {
            display: 'flex',
            flexDirection: 'column',
            gap: '8px'
        }
    }, /*#__PURE__*/ React.createElement(Box, {
        component: "h3",
        sx: headingStyle
    }, constants.settings_contact_number_heading), /*#__PURE__*/ React.createElement(Box, {
        component: "p",
        sx: descriptionStyle
    }, constants.settings_contact_number_description), /*#__PURE__*/ React.createElement(TextField, {
        fullWidth: true,
        size: "small",
        value: phoneNumber,
        required: Boolean(messagePreferences.sms),
        onChange: handlePhoneNumberChange,
        disabled: !hasUpdatePermission,
        error: !!phoneNumberError,
        helperText: phoneNumberError,
        InputProps: {
            startAdornment: /*#__PURE__*/ React.createElement(Box, {
                sx: {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginRight: '8px',
                    height: '100%'
                }
            }, /*#__PURE__*/ React.createElement(Select, {
                size: "small",
                value: selectedCountry,
                onChange: handleCountryChange,
                disabled: !hasUpdatePermission,
                variant: "standard",
                disableUnderline: true,
                IconComponent: function IconComponent() {
                    return null;
                },
                onOpen: function onOpen() {
                    return setCountrySearchTerm('');
                },
                MenuProps: {
                    disablePortal: true,
                    anchorOrigin: {
                        vertical: 'bottom',
                        horizontal: 'left'
                    },
                    transformOrigin: {
                        vertical: 'top',
                        horizontal: 'left'
                    },
                    PaperProps: {
                        sx: {
                            maxHeight: '300px',
                            marginTop: '6px',
                            '& .MuiList-root': {
                                paddingTop: 0
                            }
                        }
                    }
                },
                sx: {
                    minWidth: 'auto',
                    height: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    '& .MuiSelect-select': {
                        paddingRight: '0px !important',
                        paddingLeft: '0px !important',
                        paddingTop: '0px !important',
                        paddingBottom: '0px !important',
                        display: 'flex !important',
                        alignItems: 'center !important',
                        justifyContent: 'center !important',
                        gap: '4px',
                        height: '100%',
                        margin: '0 auto',
                        width: '100%'
                    },
                    '& .MuiInputBase-root': {
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }
                },
                renderValue: function renderValue(value) {
                    var country = defaultCountries.find(function (c) {
                        return c[1] === value;
                    });
                    if (!country)
                        return null;
                    var parsedCountry = parseCountry(country);
                    return /*#__PURE__*/ React.createElement(Box, {
                        sx: {
                            display: 'flex',
                            alignItems: 'center',
                            gap: '4px',
                            height: '20px',
                            lineHeight: '20px'
                        }
                    }, /*#__PURE__*/ React.createElement(Box, {
                        sx: {
                            display: 'flex',
                            alignItems: 'center',
                            padding: '2px 4px',
                            borderRadius: '4px',
                            '&:hover': {
                                backgroundColor: 'rgba(33, 33, 33, 0.08)'
                            }
                        }
                    }, /*#__PURE__*/ React.createElement(FlagImage, {
                        iso2: parsedCountry.iso2,
                        style: {
                            width: '24px',
                            height: '18px',
                            display: 'block'
                        }
                    }), /*#__PURE__*/ React.createElement(ArrowDropDownIcon, {
                        sx: {
                            fontSize: '20px',
                            color: COLORS.textSecondary,
                            marginLeft: '-2px',
                            display: 'block'
                        }
                    })), /*#__PURE__*/ React.createElement(Box, {
                        sx: {
                            width: '1px',
                            height: '16px',
                            backgroundColor: COLORS.border,
                            opacity: 0.5
                        }
                    }), /*#__PURE__*/ React.createElement(Box, {
                        sx: {
                            fontSize: '16px',
                            color: COLORS.textSecondary,
                            fontWeight: 400,
                            lineHeight: '28px',
                            marginLeft: '6px'
                        }
                    }, "+", parsedCountry.dialCode));
                }
            }, /*#__PURE__*/ React.createElement(Box, {
                sx: {
                    position: 'sticky',
                    top: 0,
                    backgroundColor: '#fff',
                    zIndex: 1,
                    padding: '12px 16px',
                    borderBottom: "1px solid ".concat(COLORS.divider)
                },
                onKeyDown: function onKeyDown(e) {
                    return e.stopPropagation();
                }
            }, /*#__PURE__*/ React.createElement(TextField, {
                size: "small",
                fullWidth: true,
                placeholder: "Search",
                value: countrySearchTerm,
                onChange: function onChange(e) {
                    return setCountrySearchTerm(e.target.value);
                },
                onClick: function onClick(e) {
                    return e.stopPropagation();
                },
                autoFocus: true,
                InputProps: {
                    startAdornment: /*#__PURE__*/ React.createElement(Box, {
                        component: "span",
                        sx: {
                            marginRight: '8px',
                            color: COLORS.textSecondary,
                            display: 'flex',
                            alignItems: 'center',
                            fontSize: '18px'
                        }
                    }, /*#__PURE__*/ React.createElement(SearchIcon, {
                        sx: {
                            fontSize: '20px'
                        }
                    }))
                },
                sx: {
                    '& .MuiOutlinedInput-root': {
                        backgroundColor: '#F5F5F5',
                        borderRadius: '8px',
                        '& fieldset': {
                            border: 'none'
                        },
                        '&:hover fieldset': {
                            border: 'none'
                        },
                        '&.Mui-focused': {
                            backgroundColor: '#F5F5F5',
                            '& fieldset': {
                                border: 'none'
                            }
                        }
                    },
                    '& .MuiOutlinedInput-input': {
                        padding: '10px 12px',
                        fontSize: '14px',
                        fontFamily: 'Open Sans',
                        '&::placeholder': {
                            color: COLORS.textSecondary,
                            opacity: 0.7
                        }
                    }
                }
            })), filteredCountries.length === 0 ? /*#__PURE__*/ React.createElement(MenuItem, {
                disabled: true
            }, /*#__PURE__*/ React.createElement(Box, {
                sx: {
                    fontSize: '14px',
                    color: COLORS.textSecondary,
                    textAlign: 'center',
                    width: '100%'
                }
            }, constants.settings_no_countries)) : filteredCountries.map(function (country) {
                var parsedCountry = parseCountry(country);
                return /*#__PURE__*/ React.createElement(MenuItem, {
                    key: parsedCountry.iso2,
                    value: parsedCountry.iso2
                }, /*#__PURE__*/ React.createElement(Box, {
                    sx: {
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px'
                    }
                }, /*#__PURE__*/ React.createElement(FlagImage, {
                    iso2: parsedCountry.iso2,
                    style: {
                        width: '20px',
                        height: '15px'
                    }
                }), /*#__PURE__*/ React.createElement(Box, {
                    sx: {
                        fontSize: '14px'
                    }
                }, parsedCountry.name, ' ', "(+", parsedCountry.dialCode, ")")));
            })))
        },
        sx: {
            '& .MuiOutlinedInput-root': _objectSpread(_objectSpread({
                padding: '8px 12px',
                borderRadius: '4px'
            }, inputBaseStyle), {}, {
                '& fieldset': {
                    borderColor: COLORS.border
                },
                '&:hover fieldset': {
                    borderColor: COLORS.border
                },
                '&.Mui-focused fieldset': {
                    borderColor: COLORS.primary,
                    borderWidth: '1px'
                },
                '&.Mui-error fieldset': {
                    borderColor: COLORS.error
                }
            }),
            '& .MuiOutlinedInput-input': {
                paddingBottom: '9px',
                marginTop: '1px',
                height: '20px',
                lineHeight: '20px'
            },
            '& .MuiFormHelperText-root': {
                fontFamily: 'Open Sans',
                fontSize: '12px',
                lineHeight: '128%',
                marginLeft: 0,
                marginTop: '4px'
            }
        }
    })), /*#__PURE__*/ React.createElement(Divider, {
        sx: {
            borderColor: COLORS.divider
        }
    }), /*#__PURE__*/ React.createElement(Box, {
        sx: {
            display: 'flex',
            flexDirection: 'column',
            gap: '8px'
        }
    }, /*#__PURE__*/ React.createElement(Box, {
        component: "h3",
        sx: headingStyle
    }, constants.settings_language_heading), /*#__PURE__*/ React.createElement(Box, {
        component: "p",
        sx: descriptionStyle
    }, constants.settings_language_description), /*#__PURE__*/ React.createElement(Select, {
        fullWidth: true,
        size: "small",
        value: selectedLanguage,
        disabled: !hasUpdatePermission,
        onChange: function onChange(e) {
            var lang = (e.target.value || 'en').toLowerCase();
            setSelectedLanguage(lang);
        },
        sx: _objectSpread(_objectSpread({
            borderRadius: '4px'
        }, inputBaseStyle), {}, {
            '& .MuiOutlinedInput-notchedOutline': {
                borderColor: COLORS.border
            },
            '&:hover .MuiOutlinedInput-notchedOutline': {
                borderColor: COLORS.border
            },
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                borderColor: COLORS.primary,
                borderWidth: '1px'
            },
            '& .MuiSelect-select': {
                padding: '12px',
                height: '20px',
                display: 'flex',
                alignItems: 'center'
            }
        })
    }, languageOptions.map(function (opt) {
        return /*#__PURE__*/ React.createElement(MenuItem, {
            key: opt.code,
            value: opt.code
        }, opt.label);
    })), languageError && /*#__PURE__*/ React.createElement(Box, {
        component: "p",
        sx: _objectSpread(_objectSpread({}, descriptionStyle), {}, {
            fontSize: '12px',
            color: COLORS.error
        })
    }, languageError)), /*#__PURE__*/ React.createElement(Divider, {
        sx: {
            borderColor: COLORS.divider
        }
    }), /*#__PURE__*/ React.createElement(Box, {
        sx: {
            display: 'flex',
            flexDirection: 'column',
            gap: '8px'
        }
    }, /*#__PURE__*/ React.createElement(Box, {
        component: "h3",
        sx: headingStyle
    }, constants.settings_audio_heading), /*#__PURE__*/ React.createElement(Box, {
        sx: {
            display: 'flex',
            alignItems: 'center',
            gap: '8px'
        }
    }, /*#__PURE__*/ React.createElement(Box, {
        component: "span",
        sx: _objectSpread(_objectSpread({}, descriptionStyle), {}, {
            color: COLORS.textPrimary
        })
    }, constants.settings_audio_off), /*#__PURE__*/ React.createElement(Box, {
        onClick: function onClick() {
            return hasUpdatePermission && setAudio(!audio);
        },
        sx: {
            position: 'relative',
            width: 48,
            height: 32,
            cursor: hasUpdatePermission ? 'pointer' : 'not-allowed',
            opacity: hasUpdatePermission ? 1 : 0.5
        }
    }, /*#__PURE__*/ React.createElement(Box, {
        sx: {
            position: 'absolute',
            left: 6,
            top: 8,
            width: 36,
            height: 16,
            borderRadius: '10px',
            backgroundColor: audio ? (_configState$settings4 = configState === null || configState === void 0 || (_configState$settings5 = configState.settings) === null || _configState$settings5 === void 0 ? void 0 : _configState$settings5.button_color) !== null && _configState$settings4 !== void 0 ? _configState$settings4 : COLORS.primary : '#EBEBEB',
            opacity: audio ? 0.3 : 1,
            transition: 'background-color 300ms',
            pointerEvents: 'none'
        }
    }), /*#__PURE__*/ React.createElement(Box, {
        component: "button",
        role: "switch",
        "aria-checked": audio,
        "aria-label": constants.settings_audio_aria_label,
        sx: {
            position: 'absolute',
            left: audio ? 24 : 7,
            top: 7,
            width: 18,
            height: 18,
            borderRadius: '50%',
            backgroundColor: audio ? (_configState$settings6 = configState === null || configState === void 0 || (_configState$settings7 = configState.settings) === null || _configState$settings7 === void 0 ? void 0 : _configState$settings7.button_color) !== null && _configState$settings6 !== void 0 ? _configState$settings6 : COLORS.primary : '#D9D9D9',
            boxShadow: '0px 2px 1px rgba(0, 0, 0, 0.15), 0px 0px 2px rgba(0, 0, 0, 0.12), 0px 1px 1px rgba(0, 0, 0, 0.15)',
            transition: 'left 300ms cubic-bezier(0.4, 0, 0.2, 1), background-color 300ms',
            cursor: 'pointer',
            border: 'none',
            padding: 0,
            pointerEvents: 'none',
            '&:focus': {
                outline: "2px solid ".concat(COLORS.primary),
                outlineOffset: '2px'
            }
        }
    })), /*#__PURE__*/ React.createElement(Box, {
        component: "span",
        sx: descriptionStyle
    }, constants.settings_audio_on))), !channelsLoading && enabledChannels.length > 0 && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Divider, {
        sx: {
            borderColor: COLORS.divider
        }
    }), /*#__PURE__*/ React.createElement(Box, {
        sx: {
            display: 'flex',
            flexDirection: 'column',
            gap: '8px'
        }
    }, /*#__PURE__*/ React.createElement(Box, {
        component: "div"
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h3",
        sx: headingStyle
    }, constants.settings_message_preferences_heading), /*#__PURE__*/ React.createElement(Typography, {
        variant: "body1",
        sx: descriptionStyle
    }, constants.settings_message_preferences_description)), enabledChannels.map(function (channel) {
        var translatedLabel = getChannelLabelFromConstants(channel.key, channel.label);
        return /*#__PURE__*/ React.createElement(ChannelToggleItem, {
            key: channel.key,
            channel: _objectSpread(_objectSpread({}, channel), {}, {
                label: translatedLabel
            }),
            messagePreferences: messagePreferences,
            notificationPermission: notificationPermission,
            renderChannelToggle: renderChannelToggle,
            toggleInBrowser: toggleInBrowser,
            toggleMessagePreference: toggleMessagePreference
        });
    })))), /*#__PURE__*/ React.createElement(SettingsFooter, {
        onClose: onClose,
        handleSave: handleSave,
        languageLoading: languageLoading,
        preferredNameError: preferredNameError,
        phoneNumberError: phoneNumberError,
        isDirty: isDirty,
        hasUpdatePermission: hasUpdatePermission,
        buttonColor: (_configState$settings8 = configState === null || configState === void 0 || (_configState$settings9 = configState.settings) === null || _configState$settings9 === void 0 ? void 0 : _configState$settings9.button_color) !== null && _configState$settings8 !== void 0 ? _configState$settings8 : COLORS.primary
    })));
};
export default SettingsModal;
